import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2";
import $ from "jquery";
import Breadcrums from "../../../common/breadcrumbs";
import { PER_PAGE_OPTIONS, SWAL_SETTINGS, THEME_COLORS } from "../../../../../utils/Constants";
import {
  TrimText,
  copyText,
  formateDateWithMonth,
  groupPermissions,
  handleServerValidations,
  hasP,
} from "../../../../../utils/commonfunction";
import Sorting from "../../../common/sorting";
import * as Permission from "../../../services/permission.service";
import { useTranslation } from "react-i18next";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import { useQuery } from "react-query";
import Pagination from "../../../common/Pagination";

const PermissionList = () => {
  const params = useParams();
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [statsupdate, setStatusUpdate] = useState("false");
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [perPage, setPerPage] = useState(200);
  const [filters, setFilters] = useState({});
  const [sortingChanged, setSortingChanged] = useState(false);
  const location = useLocation();

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_permissions"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);


  /** Pagination starts >>>> */
  const [pageIndex, setPageIndex] = useState(Number(params.pgno) - 1);
  const [cursorStack, setCursorStack] = useState([null]);
  const [lastKey, setLastKey] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const devParam = queryParams.get('dev');
  const showAddButton = devParam === 'true';
  const [isDevMode, setIsDevMode] = useState(showAddButton);

  useEffect(() => {
    setIsDevMode(showAddButton);
  }, [showAddButton]);

  /** Getting list */
  const { data, isLoading, status, refetch } = useQuery({
    queryKey: ["cms-list", perPage, pageIndex, filters, sortingChanged],
    queryFn: () => Permission.List({
      limit: perPage, lastKey, filters, sorting
    }),
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (res) => {
      setSorting(res?.data?.sorting);
    },
    onError: (error) => {
      Swal.fire({
        icon: "error",
        text: handleServerValidations(error),
        ...SWAL_SETTINGS,
      });
    },
  });

  console.log("Permission List data", data?.data?.list ? Object.groupBy(data?.data?.list, (item) => item?.groupName) : []);

  useEffect(() => {
    if (status === "success") {
      setCursorStack((prev) => {
        const copy = [...prev];
        copy[pageIndex + 1] = data?.data?.lastKey || null;
        return copy;
      });
      setLastKey(data.lastKey || null);
    }
  }, [status, data, pageIndex]);

  const nextPage = () => {
    if (!data?.data?.hasMore) return;
    const nextIndex = pageIndex + 1;
    setPageIndex(nextIndex);
    setLastKey(cursorStack[nextIndex] ?? data.data.lastKey);
    navigate(`/admin/permission-management/permission/list/${nextIndex + 1}`);
  };
  const prevPage = () => {
    if (pageIndex === 0) return;
    const prevIndex = pageIndex - 1;
    setPageIndex(prevIndex);
    setLastKey(cursorStack[prevIndex] ?? null);
    navigate(`/admin/permission-management/permission/list/${prevIndex + 1}`);
  };
  useEffect(() => {
    setPageIndex(0);
    setLastKey(null);
    setCursorStack([null]);
    refetch();
  }, [perPage]);

  useEffect(() => {
    const pg = Number(params.pgno) - 1;
    setPageIndex(pg);
    setLastKey(cursorStack[pg] ?? null);
  }, [params.pgno]);

  /** Pagination ends <<<< */
  const viewfunction = (row) => {
    navigate(`/admin/permission-management/permission/view/${row.id}`);
  };
  const Editfunction = (row) => {
    navigate(`/admin/permission-management/permission/${params.pgno}/edit/${row.id}`);
  };

  const handleCopy = (text) => {
    copyText(text);
    Swal.fire({
      icon: 'success',
      text: 'Copied',
      ...SWAL_SETTINGS,
    })
  };

  function Deletefunction(data) {

    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        let id = [data.id];
        formdata.append("o_id", JSON.stringify(id));
        Permission
          .Delete(data.id)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setPageIndex(0);
              setLastKey(null);
              setCursorStack([null]);
              refetch();
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }


  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: "", column: column };
    if (e.target.classList.contains("ascending")) {
      sort.order = "descending";
    } else {
      sort.order = "ascending";
    }
    setSorting(sort);
    setSortingChanged(!sortingChanged);
  };


  const toggleActions = (record, action) => {
    if (isDevMode) {
      $(".actions-container").hide();
      if (action) {
        $("#" + record.id).toggle("show");
      }
    }
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("label_permissions")}</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">

                </div>
                <div className="me-3">
                </div>

                {/* {
                  hasP("permissions-add"&& isDevMode) ?
                    <button
                      className="btn ripple btn-main-primary signbtn"
                      onClick={() => navigate(`/admin/permission-management/permission/pages/add${isDevMode ? "?dev=true" : ""}`)}
                    >
                      {t("btn_add_new")}
                    </button> : null} */}
                {isDevMode && (
                  <button
                    className="btn ripple btn-main-primary signbtn"
                    onClick={() => navigate(`/admin/permission-management/permission/pages/add${isDevMode ? "?dev=true" : ""}`)}
                  >
                    {t("btn_add_new")}
                  </button>
                )}
              </div>
            </div>

            {
              isLoading ?
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                :
                <>
                  {data?.data?.list.length ?
                    <>
                      {groupPermissions(data?.data?.list).map((group, index) => (
                        <div className="card mb-4" key={index}>
                          <div className="card-body p-3">
                            <h5 className="card-title">{group.title || "Default"}</h5>
                            {
                              group?.data?.map((item, i) => (
                                <div className="position-relative d-inline-block">
                                  <span className={"badge badge-pill badge-primary-light me-2 mb-1" + (isDevMode ? " cp" : "")} key={i} onClick={() => { toggleActions(item, true) }}>{item?.title || "Unknown"}</span>
                                  <div className="position-absolute bg-white p-2 border border-1 rounded-2 actions-container" id={item?.id} style={{ zIndex: 1, left: "50%", transform: "translateX(-50%)", top: "-20px", display: 'none' }} >
                                    <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                      <div className="btn-group btn-group-sm position-relative" role="group" aria-label="Second group">
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                          <button type="button" className="btn view" onClick={() => { viewfunction(item); }}>
                                            <i className="ri-eye-fill"></i>
                                          </button>
                                        </Whisper>
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Edit</Tooltip>}>
                                          <button type="button" className="btn edit" onClick={() => { Editfunction(item); }}>
                                            <i className="ri-pencil-fill"></i>
                                          </button>
                                        </Whisper>
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Delete</Tooltip>}>
                                          <button type="button" className="btn delete" onClick={() => { Deletefunction(item) }}>
                                            <i className="ri-delete-bin-6-fill"></i>
                                          </button>
                                        </Whisper>
                                        <span className="position-absolute cp" style={{ top: '-16px', right: '-14px', zIndex: 2 }} onClick={() => { toggleActions(item) }}><i style={{ fontSize: "18px" }} className="ri-close-circle-fill text-danger"></i></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      ))}
                    </>
                    : null}
                </>
            }
          </div>
          <div></div>
        </div>
      </div>
      {/* tablesection end */}

    </>
  );
};

export default PermissionList;